import CustomButtonComponent from "../../../../components/PayAnalytics/CommonComponents/CustomButtonComponent";
import { Skeleton, Typography } from "@mui/material";
import NoDataIcon from "../../../../assets/images/list-noData-icon.svg";
import { useTranslation } from "react-i18next";
import Styles from "./index.module.scss";
import { useSelector } from "react-redux";

export const NoDataListScreen = () => {
  const { t } = useTranslation();
  const { jobPricingList, country } = useSelector((state: any) => {
    return state;
  });
  return (
    <div className={Styles.noRowsOverlayContainer}>
      <img src={NoDataIcon} />
      <Typography className={Styles.noResultsHeader}>
        {/* {t("pa.noResultsFoundForYourSearch")} {jobPricingList?.searchKey}
         */}
        {jobPricingList?.responseMessage}
      </Typography>
      {/* <div className={Styles.noResultsDescription}>
        <Typography>
          {t("pa.noResultsFoundForYourSearch.description")}
        </Typography>
        <ul>
          <li itemType="dot">
            {t("pa.noResultsFoundForYourSearch.descriptionP1")}
          </li>
          <li>{t("pa.noResultsFoundForYourSearch.descriptionP2")}</li>
          <li>{t("pa.noResultsFoundForYourSearch.descriptionP3")}</li>
        </ul>
      </div> */}
      {/* <CustomButtonComponent
        text={t("pa.startaNewSearchBtnText")}
        variant={"contained"}
        onClick={() => {}}
      /> */}
    </div>
  );
};

export const LoadingOverlay = ({ columsList }: any) => {
  const renderColumns = () => {
    return (
      <>
        {columsList.map((data: any, colIndex: number) => (
          <Skeleton
            key={colIndex}
            sx={{ flexGrow: data?.flex || 1 }}
            height={"30px"}
          />
        ))}
      </>
    );
  };
  return (
    <div className={Styles.loadingSpinnerContainer}>
      {Array.from({ length: 10 }).map((_, colIndex) => (
        <div key={colIndex} className={Styles.loadingSpinner}>
          {renderColumns()}
        </div>
      ))}
    </div>
  );
};
